import React from 'react'
import ProductDetailsInfo from './ProductDetailsInfo'
// import RelatedProduct from './RelatedProduct'

const ProductDetails = () => {
  return (
    <div>
        <ProductDetailsInfo/>
        {/* <RelatedProduct/> */}
    </div>
  )
}

export default ProductDetails